import React, { useEffect, useState } from 'react';
import { Route, Routes } from "react-router-dom";
import { AboutPage } from "./pages/AboutPage";
import { Header } from "./components/Header";
import { ContactsPage } from "./pages/ContactsPage";
import './styles/custom-scroll.scss';
import './App.scss';
import { TourSearchPage } from "./pages/TourSearchPage";
import { ToursPage } from "./pages/ToursPage";
import { NewsPage } from "./pages/NewsPage";
import { Footer } from "./components/Footer";
import { FeedbacksPage } from "./pages/FeedbackPage";
import { CruiseSearchPage } from "./pages/CruiseSearchPage";
import { PayPage } from "./pages/PayPage";
import { Spinner } from "./components/Spinner";
import { NewsDetailPage } from "./pages/NewsDetailPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { CookiePolicyPage } from "./pages/CookiePolicyPage";
import { CookieConsentBanner } from "./components/CookieConsentBanner";

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1000);
    }, [])

    return (
        <>
            {loading ? (
                <Spinner/>
            ) : (<>
                    <Header/>
                    <main>
                        <Routes>
                            <Route
                                path='/'
                                element={<TourSearchPage/>}
                            ></Route>
                            <Route
                                path='/tours'
                                element={<ToursPage/>}
                            ></Route>
                            <Route
                                path='/cruises'
                                element={<CruiseSearchPage/>}
                            ></Route>
                            <Route
                                path='/about'
                                element={<AboutPage/>}
                            ></Route>
                            <Route
                                path='/contacts'
                                element={<ContactsPage/>}
                            ></Route>
                            <Route
                                path='/news'
                                element={<NewsPage/>}
                            ></Route>
                            <Route
                                path='/news/:slug'
                                element={<NewsDetailPage/>}
                            ></Route>
                            <Route
                                path='/pay'
                                element={<PayPage/>}
                            ></Route>
                            <Route
                                path='/feedback'
                                element={<FeedbacksPage/>}
                            ></Route>
                            <Route
                                path='/privacy-policy'
                                element={<PrivacyPolicyPage/>}
                            ></Route>
                            <Route
                                path='/cookie-policy'
                                element={<CookiePolicyPage/>}
                            ></Route>
                        </Routes>
                    </main>
                    <Footer/>
                    <CookieConsentBanner/>
                </>
            )}
        </>
    )
}

export default App;
